import Navigation from './navigation/components/navigation';

DeferredEvents.listen('navigation_init', function(event) {
    ReactDOM.render(
        <Navigation
            currentCategoryIds={event.getData().currentCategoryIds}
            catalogLinks={event.getData().catalogLinks}
            otherLinks={event.getData().otherLinks}
            flags={event.getData().flags}
        />,
        $j('#navigation-wrapper')[0]
    );
    console.log('navigation_init');
});
